<template>
  <div class="navbar">
    <!-- 折叠按钮 -->
    <div class="hamburger-container" @click="toggleSidebar">
      <i :class="sidebar.opened ? 'el-icon-s-fold' : 'el-icon-s-unfold'" class="hamburger-icon" />
    </div>

    <!-- 面包屑 -->
    <el-breadcrumb class="breadcrumb-container" separator="/">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item
          v-for="(item, index) in levelList"
          :key="item.path"
        >
          <span
            v-if="item.redirect === 'noRedirect' || index === levelList.length - 1"
            class="no-redirect"
          >{{ item.meta.title }}</span>
          <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>

    <!-- 右侧操作区 -->
    <div class="right-menu">

      <!-- 用户下拉菜单 -->
      <el-dropdown class="avatar-container right-menu-item" trigger="click">
        <div class="avatar-wrapper">
          <el-avatar
            :size="30"
            :src="userInfo.avatar || defaultAvatar"
            class="user-avatar"
          />
          <span class="username">{{ userInfo.nickname || userInfo.username }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/profile/index">
            <el-dropdown-item>
              <i class="el-icon-user" /> 个人中心
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="handleLogout">
            <i class="el-icon-switch-button" /> 退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Navbar',
  data() {
    return {
      defaultAvatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
      isFullscreen: false,
      levelList: []
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'userInfo'])
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    ...mapActions({ toggleSideBarAction: 'settings/toggleSideBar' }),
    toggleSidebar() {
      this.toggleSideBarAction()
    },
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]
      if (!this.isDashboard(first)) {
        matched = [{ path: '/dashboard', meta: { title: '首页' } }].concat(matched)
      }
      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    },
    isDashboard(route) {
      const name = route && route.name
      return name && name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
      } else {
        this.$router.push(path)
      }
    },
    toggleFullscreen() {
      try {
        const isInFullscreen =
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement

        if (!isInFullscreen) {
          const el = document.documentElement
          const req =
            el.requestFullscreen ||
            el.webkitRequestFullscreen ||
            el.mozRequestFullScreen ||
            el.msRequestFullscreen
          if (req) {
            // 旧版 webkit 不返回 Promise，需判断后再 catch
            const p = req.call(el)
            if (p && typeof p.catch === 'function') p.catch(() => {})
          }
          this.isFullscreen = true
        } else {
          const exit =
            document.exitFullscreen ||
            document.webkitExitFullscreen ||
            document.mozCancelFullScreen ||
            document.msExitFullscreen
          if (exit) {
            const p = exit.call(document)
            if (p && typeof p.catch === 'function') p.catch(() => {})
          }
          this.isFullscreen = false
        }
      } catch (e) {
        // 浏览器不支持或权限被拒绝，静默处理
      }
    },
    async handleLogout() {
      try {
        await this.$confirm('确认退出登录？', '提示', {
          confirmButtonText: '确认退出',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await this.$store.dispatch('user/logout')
        this.$router.push('/login')
      } catch {}
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;

  .hamburger-container {
    line-height: 52px;
    height: 100%;
    float: left;
    cursor: pointer;
    padding: 0 15px;
    transition: background 0.3s;
    &:hover { background: rgba(0, 0, 0, 0.025); }

    .hamburger-icon {
      font-size: 20px;
      color: #5a5e66;
    }
  }

  .breadcrumb-container {
    float: left;
    flex: 1;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }

  .right-menu {
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;
    padding-right: 16px;
    gap: 10px;

    .right-menu-item {
      display: flex;
      align-items: center;
      height: 100%;
      padding: 0 8px;
      font-size: 18px;
      color: #5a5e66;
      cursor: pointer;
      vertical-align: text-bottom;
      transition: background 0.3s;
      &:hover { background: rgba(0, 0, 0, 0.025); }
    }

    .avatar-container {
      .avatar-wrapper {
        display: flex;
        align-items: center;
        gap: 6px;
        cursor: pointer;
        padding: 0 8px;

        .user-avatar {
          cursor: pointer;
          border-radius: 50%;
        }
        .username {
          font-size: 14px;
          color: #5a5e66;
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .el-icon-caret-bottom {
          font-size: 12px;
          color: #5a5e66;
        }
      }
    }
  }
}
</style>
